import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import BaseDialog from '../../dialogs/BaseDialog';

const RESPONSIVE_MODE = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
};

const DISPLAY_LIMIT_BY_MODE = {
  [RESPONSIVE_MODE.MOBILE]: 10,
  [RESPONSIVE_MODE.DESKTOP]: 14,
};

function BetSelectionUsersDialog({
  colorSet,
  displayLabel,
  isVisible,
  onClose,
  responsiveMode = RESPONSIVE_MODE.DESKTOP,
  users = [],
}) {
  const limit = DISPLAY_LIMIT_BY_MODE[responsiveMode] ?? DISPLAY_LIMIT_BY_MODE[RESPONSIVE_MODE.DESKTOP];
  const visibleUsers = users.slice(0, limit);
  const hasMore = users.length > visibleUsers.length;
  const displayUsers = hasMore ? [...visibleUsers, { name: '他', isOther: true }] : visibleUsers;

  return (
    <BaseDialog
      isVisible={isVisible}
      onClose={onClose}
      maxWidth={responsiveMode === RESPONSIVE_MODE.MOBILE ? 'min(92vw, 360px)' : 'min(92vw, 420px)'}
      padding={responsiveMode === RESPONSIVE_MODE.MOBILE ? '16px' : '18px'}
    >
      <Box sx={{ minWidth: 0 }}>
        <Box sx={{ fontSize: '16px', fontWeight: 900, color: colorSet?.primary || '#263238', mb: 0.5 }}>
          {displayLabel} を選んでいるユーザー
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          {displayUsers.map((user, index) => (
            <Box
              key={`${user.name}-${index}`}
              sx={{
                minHeight: '28px',
                px: 1,
                py: 0.55,
                borderRadius: '8px',
                bgcolor: user.isOther ? 'rgba(15, 23, 42, 0.05)' : 'rgba(255,255,255,0.86)',
                border: `1px solid ${user.isOther ? 'rgba(15, 23, 42, 0.10)' : (colorSet?.border || 'rgba(15, 23, 42, 0.10)')}`,
                color: user.isOther ? 'rgba(15, 23, 42, 0.58)' : 'rgba(15, 23, 42, 0.86)',
                fontSize: '13px',
                fontWeight: 800,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {user.name}
            </Box>
          ))}
        </Box>

        <Box sx={{ mt: 1.5, display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{ minWidth: 88, height: 34, fontSize: '13px', fontWeight: 900, textTransform: 'none' }}
          >
            閉じる
          </Button>
        </Box>
      </Box>
    </BaseDialog>
  );
}

export default BetSelectionUsersDialog;
